export default __webpack_public_path__ + "static/media/img_06.ca812d1d.svg";